<script>
import html2canvas from 'html2canvas';
import {toNumChines} from '@/untils/common';

export default {
  name: 'openWinner',
  data() {
    return {
      page1:1,//当前页
      size1:10,//每页条数
      activeTab: '12',
      dataList:[],
      dataObj1:{
        // "saleCdc": 8426,
        // "saleDate": "2023-12-27 21:15:00",
        // "gameCode": "8",
        // "drawNum": 2023149,
        // "winId": 0,
        // "winNum": "03 07 13 17 18 21 28",
        // "winPower": "22",
        // "gameName": null
      },
      dataObj2:{
        // "gameId": "10003",
        // "drawNum": "2023149",
        // "localSales": "6831800",
        // "allSales": "336208000",
        // "winNumber": [
        //     {
        //         "groupIdx": "1",
        //         "winNumberDetail": "03171328211807@22"
        //     }
        // ],
        // "winDetail": [
        //     {
        //         "winLevel": "1",
        //         "winName": "一等奖",
        //         "localWinCount": "0",
        //         "allWinCount": "1",
        //         "prizeAmount": "782826"
        //     },
        //     {
        //         "winLevel": "2",
        //         "winName": "二等奖",
        //         "localWinCount": "0",
        //         "allWinCount": "5",
        //         "prizeAmount": "22366"
        //     },
        //     {
        //         "winLevel": "3",
        //         "winName": "三等奖",
        //         "localWinCount": "0",
        //         "allWinCount": "140",
        //         "prizeAmount": "1597"
        //     },
        //     {
        //         "winLevel": "4",
        //         "winName": "四等奖",
        //         "localWinCount": "5",
        //         "allWinCount": "339",
        //         "prizeAmount": "200"
        //     },
        //     {
        //         "winLevel": "5",
        //         "winName": "五等奖",
        //         "localWinCount": "73",
        //         "allWinCount": "3799",
        //         "prizeAmount": "50"
        //     },
        //     {
        //         "winLevel": "6",
        //         "winName": "六等奖",
        //         "localWinCount": "118",
        //         "allWinCount": "5908",
        //         "prizeAmount": "10"
        //     },
        //     {
        //         "winLevel": "7",
        //         "winName": "七等奖",
        //         "localWinCount": "753",
        //         "allWinCount": "42453",
        //         "prizeAmount": "5"
        //     }
        // ],
        // "winPool": [
        //     {
        //         "poolName": "本期全国销量",
        //         "poolBalanceMoney": "3362080元"
        //     },
        //     {
        //         "poolName": "奖池累计金额",
        //         "poolBalanceMoney": "0元"
        //     },
        //     {
        //         "poolName": "本西藏市销量",
        //         "poolBalanceMoney": "68318元"
        //     }
        // ]
      },
      tabIndexKl8:'10',
    }
  },
  watch: {
    // 监控参数变化更新游戏列表接口数据
    listParams: function () {
      this.getDataInit();
    },
    searchParams: function () {
      this.getHappy();
    },
  },
  computed: {
    // 监控参数变化更新游戏列表接口数据
    listParams() {
      return {
        gameCode:this.activeTab,//双色球是12，快乐8是22，3D是9，七乐彩是8
        pageSize:this.size1,
        pageNum:this.page1,
      };
    },
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        code: this.tabIndexKl8,
      };
    },
  },
  methods: {
    capture() {
      html2canvas(this.$refs.capture).then(canvas => {
        // 转换为图片并下载
        const link = document.createElement('a');
        // link.download = 'screenshot.png';
        link.href = canvas.toDataURL('image/png');
        console.log(link.href)
        // link.click();
      });
    },
    getDataInit(){
      this.$http.lottery_drawwinNumber_list(this.listParams).then((res)=>{
        if(res){
          if(res.code===200){
            if (res.rows == null || res.rows.length === 0) {
              this.listdata = [];
              return false;
            }else{
              if(this.page1>1){
                this.listdata = this.listdata.concat(res.rows);
              }else{
                this.listdata = res.rows;
                this.getInit(this.listParams.gameCode,res.rows[0].drawNum);
                this.getData(this.listParams.gameCode,res.rows[0].drawNum);
              }
            }
          }
        }
      });
    },
    getInit(name,dram){
      this.$http.lottery_drawwinNumber_detailes({
        gameCode:name,
        drawNum:dram,
      }).then((res)=>{
        if(res){
          if(res.code===200){
            this.dataObj1 = res.data;
            this.dataObj1.redBall = res.data.winNum.split(' ');//1,2,3转换为[1,2,3]
            //蓝 球中奖号码
            if(res.data.winPower){
              this.dataObj1.blueBall = res.data.winPower;
            }
          }
        }
      })
    },
    getData(name,dram){
      this.$http.lottery_winbullInfo_windetailes({
        gameCode:name,
        drawNum:dram,
      }).then((res)=>{
        if(res){
          if(res.code===200){
            this.dataObj2 = res.data;
            let arr = []
            if(this.tabIndexKl8==='10'){
              res.data.winDetail.map((v)=>{
                v.keys = toNumChines(v.winName.substring(v.winName.length-1,v.winName.length));
                if(v.winName.substring(0,2)==='选十'){
                  arr.push(v);
                }
              })
            }
            this.dataObj2.winDetailArr = arr;
          }
        }
      })
    },
    getHappy() {
      let arr = [];
      if (this.searchParams.code === '10') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选十') {
            arr.push(v);
          }
        })
      } else if (this.searchParams.code === '9') {
        this.dataObj2.winDetail.map((v) => {
          if (v.winName === '选九全中') {
            v.winName = '选九中九';
          }
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选九') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '8') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选八') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '7') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选七') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '6') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选六') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '5') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选五') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '4') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选四') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '3') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选三') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '2') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选二') {
            arr.push(v);
          }
        });
      } else if (this.searchParams.code === '1') {
        this.dataObj2.winDetail.map((v) => {
          v.keys = toNumChines(v.winName.substring(v.winName.length - 1, v.winName.length));
          if (v.winName.substring(0, 2) === '选一') {
            arr.push(v);
          }
        });
      }
      this.dataObj2.winDetailArr = arr;
    },
  },
  created() {
    // 查询当前游戏的往期游戏
    this.getDataInit();
  }
}
</script>

<template>
  <div class="content">
    <div class="tabs">
      <van-tabs v-model="activeTab" animated swipeable sticky>
        <van-tab title="双色球" name="12"></van-tab>
        <van-tab title="快乐8" name="22"></van-tab>
        <van-tab title="福彩3D" name="9"></van-tab>
        <van-tab title="七乐彩" name="8"></van-tab>
      </van-tabs>
    </div>
    <div class="page-content" ref="capture">
      <div class="pad">
        <div class="card-group">
          <div class="card-group-item">
            <div class="card-group-item-img">
              <img v-if="activeTab==='12'" src="@/assets/images/1.png" alt=""/>
              <img v-else-if="activeTab==='22'" src="@/assets/images/4.png" alt=""/>
              <img v-else-if="activeTab==='9'" src="@/assets/images/2.png" alt=""/>
              <img v-else-if="activeTab==='8'" src="@/assets/images/3.png" alt=""/>
            </div>
            <div class="card-group-item-data">
              <div class="group-item-title radios">
                <div class="card-title-data">
                  <span class="name">
                      {{activeTab==='12'?'双色球':''}}
                      {{activeTab==='22'?'快乐8':''}}
                      {{activeTab==='9'?'福彩3D':''}}
                      {{activeTab==='8'?'七乐彩':''}}
                  </span> 第{{dataObj1.drawNum}}期
                  <span class="time">{{dataObj1.saleDate}}</span>
                </div>
              </div>
              <div class="group-item-list">
                <div class="list-box-item">
                  <div class="group-item-box">
                    <div class="item-list-ball" v-if="dataObj1.redBall">
                      <span v-for="(v,index) in dataObj1.redBall" :key="index">{{ v }}</span>
                    </div>
                    <div class="item-list-ball" v-if="dataObj1.winPower">
                      <span class="blue">{{ dataObj1.winPower }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="label-info">
          <div class="info-item" v-for="(item,index) in dataObj2.winPool" :key="index" v-show="item.poolBalanceMoney!=='0.00元'&&item.poolBalanceMoney!=='0元'">
            {{item.poolName}}：{{item.poolBalanceMoney}}
          </div>
        </div>
        <div class="table-group" v-if="activeTab==='22'">
          <van-tabs v-model="tabIndexKl8">
            <van-tab title="选十" name="10"></van-tab>
            <van-tab title="选九" name="9"></van-tab>
            <van-tab title="选八" name="8"></van-tab>
            <van-tab title="选七" name="7"></van-tab>
            <van-tab title="选六" name="6"></van-tab>
            <van-tab title="选五" name="5"></van-tab>
            <van-tab title="选四" name="4"></van-tab>
            <van-tab title="选三" name="3"></van-tab>
            <van-tab title="选二" name="2"></van-tab>
            <van-tab title="选一" name="1"></van-tab>
          </van-tabs>
          <div class="table-group">
            <!--              除了快乐8有 全国中奖注数 其他游戏没有 全国中奖注数   -->
            <table border="0" cellspacing="0">
              <tr>
                <th>中奖个数</th>
                <th>全国中奖注数</th>
                <th>西藏中奖注数</th>
                <th>每注金额（元）</th>
              </tr>
              <tr v-for="(item,index) in dataObj2.winDetailArr" :key="index">
                <td>{{ item.keys?item.keys:0 }}</td>
                <td>{{ item.allWinCount }}</td>
                <td>{{ item.localWinCount }}</td>
                <td>{{ item.prizeAmount }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="table-group" v-else>
          <table border="0" cellspacing="0">
            <tr>
              <th>奖等</th>
              <th v-if="activeTab!=='9'">全国中奖注数</th>
              <th>西藏中奖注数</th>
              <th>每注金额（元）</th>
            </tr>
            <tr v-for="(item,index) in dataObj2.winDetail" :key="index" v-if="item.winName!=='幸运二等奖'">
              <td>{{ item.winName }}</td>
              <td v-if="activeTab!=='9'">{{ item.allWinCount===''||item.allWinCount==null?'-':item.allWinCount }}</td>
              <td>{{ item.localWinCount }}</td>
              <td>{{ item.prizeAmount }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!--    <div><van-button @click="capture">点击分享图片</van-button></div>-->
  </div>
</template>
<style lang="scss" scoped>
//.content{
//  padding-top: 120px;
//  box-sizing: border-box;
//}
.card-group {
  height: 100%;
  width: 100%;
  background: white;
  .card-group-item {
    margin: 8px 0;
    border-bottom: 1px solid #ddd;
    display: flex;
    -webkit-box-orient: horizontal;

    .card-group-item-img {
      display: flex;
      width: 15%;
      justify-content: center;
      align-items: center;

      img {
        max-height: 90px;
        width: 90px;
      }
    }

    .card-group-item-data {
      width: 85%;

      .group-item-title {
        padding: 20px 6px 0;
        box-sizing: border-box;

        .card-title-data {
          width: 100%;
          padding: 0;
          box-sizing: border-box;

          img {
            width: 40px;
            height: 40px;
            vertical-align: middle;
            margin-top: -7px;
            margin-right: 10px;
          }

          .name {
            font-size: 32px;
            font-weight: bold;
          }

          .time {
            color: #aaa;
            padding-left: 6px;
          }
        }

        .card-title-date {
          height: 60px;
          color: #8f8f8f;
          width: 100%;
        }
      }

      .group-item-list {
        width: 100%;
        display: flex;
        -webkit-box-orient: vertical;
        padding-top: 10px;
        box-sizing: border-box;
        .list-box-item {
          display: flex;
          -webkit-box-orient: horizontal;
          padding: 0 0 20px;
          box-sizing: border-box;
          width: 100%;
          &:first-child {
            .item-label {
              border-top: none;
            }
          }

          .group-item-box {
            display: flex;
            width: 100%;
            .item-list-ball {
              display: inline-block;
              color: #fff;

              span {
                display: inline-block;
                background: #dc2a2a;
                width: 50px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                margin: 2px 6px;
                border-radius: 100%;;
              }

              .blue {
                background: #5980ff;
              }
            }
          }
        }
      }
    }
  }
}

.label-info {
  padding: 10px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;

  .info-item {
    padding: 10px 0;
  }
}

.table-group {
  padding: 10px;
  background: #fff;

  table {
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;

    tr {
      th {
        font-weight: normal;
        padding: 20px 0;
        text-align: center;
        //font-size:26px;
        color: #aaa;
        border-bottom: 1px solid #ddd;
      }
    }

    tr {
      td {
        padding: 20px 0;
        text-align: center;
        border-bottom: 1px solid #ddd;

      }

      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
}

</style>
